import { JUNE_SO } from "@stadium/services/analytics/constants/services";

export const SHOP_LISTING = "shop-listing";
export const PREVIEW_TEMPLATE = "preview-template";
export const USE_TEMPLATE = "use-template";
export const SEND_SHOP_CREDITS = "send-shop-credits";
export const LAYOUT_LOGO = "logo";
export const LAYOUT_HERO_BANNER = "hero-banner";
export const EDIT_CATALOG = "edit-catalog";
export const MY_SHOPS = "myshops";
export const SHOP_DASHBOARD = "shop-dashboard";
export const CATALOG = "catalog";
export const GENERAL_SETTINGS = "general-settings";
export const LAYOUT = "layout";
export const EDIT_CATEGORIES = "edit-categories";
export const ELLIPSIS = "ellipsis";
export const RESTORE_TO_DEFAULT_CATALOG = "restore-default-catalog";
export const CREATE_SHOP = "create-shop";
export const SAVE_CHANGES_CTA = "save-changes";
export const NEXT_CTA = "next";
export const UPLOAD_CSV_CTA = "upload-csv";
export const FILTER_CTA = "filter";
export const APPLY_CHANGES_CTA = "apply-changes";
export const PAY_NOW_CTA = "pay-now";
export const GO_TO_DASHBOARD = "go-to-dashboard";
export const SHOP_LINK = "shop-link";
export const DESELECT_ALL_OPTION = "deselect-all";
export const BRANDED_SWAG = "branded-swag";
export const SEND_GIFTS = "send-gifts";
export const ALL_RECIPIENTS = "all-recipients";
export const SHOP_CATALOG = "shop-catalog";
export const ADD_NEW_LOGO = "add-new-logo";
export const UNLOCK_CATALOG = "unlock-catalog";
export const PREVIEW_CATALOG = "preview-catalog";
export const EDIT_TEMPLATE = "edit-template";
export const SKIP_CTA = "skip";
export const FINISH_CTA = "finish";
export const E_DUPLICATE = "e-duplicate";
export const E_EDIT = "e-edit";
export const SELECT_ALL_OPTION = "select-all";
export const SHOP = "shop";
export const EXPIRE_GIFT = "expire-gift";
export const CANCEL_CTA = "cancel";
export const YES_CTA = "yes";
export const KITS = "kits";
export const CREATE_KIT_CTA = "create-a-kit";
export const KIT_DASHBOARD = "kit-dashboard";
export const SEND_KIT_CTA = "send-kit";
export const ADD_RECIPIENTS = "add-recipients";
export const VIEW_ORDER = "view-order";
export const SELECT_PAYMENT_METHOD = "select-payment-method";
export const SEND_INVITATION = "send-invitation";
export const RECOGNITION_PROGRAM_SETUP = "recognition-program-setup";
export const TRANSFER_SLIDER = "transfer-slider";
export const COMPLETE_ORDER = "complete-order";
export const SEND_ORDER = "send-order-flow";
export const MOMENTS_LISTING = "moments-listing";

export const CATALOG_REQUEST_DESIGN_CHANGES = "request-design-changes";
export const CATALOG_PRODUCT_EDIT_ICON = "edit-logo-icon";
export const CATALOG_PURCHASE_NEW_COLLECTION = "purchase-new-collection";

export const ADD_NEW_LOGOS = "add-new-logos";
export const CATALOG_ADD_NEW_LOGO_UPLOAD_FROM_DEVICE = "upload-from-device";
export const CATALOG_ADD_NEW_LOGO_PREVIOUS_UPLOADS = "previous-uploads";
export const CATALOG_ADD_NEW_LOGO_CREATE_COLLECTION = "create-collection";

export const BRANDED_SWAG_COLLECTION = "branded-swag-collection-ellipsis";
export const CATALOG_EDIT_COLLECTION_LOGO = "edit-collection-logo";
export const CATALOG_EDIT_CATALOG = "edit-catalog";
export const CATALOG_ALL_VIEW_ALL_PRODUCTS = "view-all-products";
export const CATALOG_ENABLE_ALL = "enable-all-in-catalog";
export const CATALOG_DISABLE_ALL = "disable-all-in-catalog";
export const ARCHIVE_CATALOG = "archive-catalog";

export const SWAG_PRODUCT = "swag-product";
export const CATALOG_PRODUCT_SAVE = "save";
export const CATALOG_PRODUCT_EDIT_COLOR_SLIDER = "color-slider";

export const VIEW_DASHBOARD = "view-dashboard";
export const DOWNLOAD_INVOICE = "downlaod-invoice";
export const DOWNLOAD_REPORT = "downlaod-report";
export const FINISH_SETUP = "finish-setup";
export const PAY_SUBMIT = "pay-submit";
export const CLOSE = "close";
export const MANAGE_CONTACTS = "manage-contacts";
export const HOME_DASHBOARD = "home-dashboard";
export const CHOOSE_PACKAGES_CHECKOUT = "full-page-select";
export const PACKAGES_CHECKOUT = "packages-checkout";
export const FEATURE_PACKAGES = "feature-packages";
export const SPEAK_WITH_EXPERT = "speak-with-an-expert";
export const FEATURE_PACKAGES_CONFIRMATION = "packages-confirmation";
export const GO_TO_ACCOUNT_SETTINGS = "go-to-account-settings";
export const GO_TO_FEATURE = "continue-to-feature";
export const GO_TO_INTAKE_FORM = "go-to-intake-form";
export const REVIEW_PAY = "review-pay";
export const SHOP_DASHBOARD_SETTINGS = "shop-dashboard-settings";
export const SHOP_DASHBOARD_INTEGRATIONS = `${SHOP_DASHBOARD_SETTINGS}-integration`;
export const SHOP_DASHBOARD_CUSTOMIZATIONS = `${SHOP_DASHBOARD_SETTINGS}-customizations`;
export const SHOP_DASHBOARD_ADD_ADMINS = `${SHOP_DASHBOARD_SETTINGS}-shop-users`;
export const ADD_USERS = "add-users";
export const PURCHASE_CUSTOMIZATION = "purchase";
export const CONTACTS = "contacts";
export const LEARN_MORE_HRIS = "learn-more-hris";
export const LEARN_MORE_CRM = "learn-more-crm";

export const CAMPAIGN_DETAIL_VIEW = "campaign";
export const CAMPAIGN_SETUP = "campaign-setup";
export const CAMPAIGN_DASHBOARD = "my-campaigns";
export const CAMPAIGN_GIFT_TYPE = "campaign-setup-gift-type-kit";
export const CREATE_CAMPAIGN = "create-new-campaign";
export const ACTIVATE_CAMPAIGN_EVENT = "activate-campaign";
export const DELETE_CAMPAIGN_EVENT = "delete-campaign";
export const CAMPAIGN_GLOBAL_REDEMPTION = "campaign-setup-gift-type-kit-country-confirmation";
export const REGENERATE_CAMPAIGN_API_KEY_EVENT = "regenerate-campaign-api-key";

export const GLOBAL_NOT_ALLOWED = "global-dont-allow";
export const GLOBAL_ALLOWED = "global-yes";

export const CREATE_KIT = "create-new-kit";

export const SHOP_REPORTS = "shop-reports";
export const SHOP_REPORTS_DOWNLOAD_EVENT = "download";
export const SHOP_REPORTS_FILTER_BY = "filter-by";
export const SHOP_REPORTS_FILTER_BY_APPLY = "filter-by-apply";
export const SHOP_REPORTS_DOWNLOAD = "shop-reports-download";
export const SHOP_REPORTS_DOWNLOAD_CSV = "download-csv";
export const SHOP_REPORTS_DOWNLOAD_PDF = "download-pdf";
export const SHOP_REPORTS_UNLOCK_REPORTS = "unlock-reports";

export const PRICELESS_SHOP = "priceless-shop";
export const POST_SHOP_CREATION = "post-shop-creation";
export const SENDER_ORDER = "sender-order";
export const SENDER = "sender";
export const APPROVE_RECIPIENTS = "approve-recipients";
export const DASHBOARD = "dashboard";
export const SETTINGS = "settings";
export const ADMIN_NO_PACKAGE_SCREEN = "admin-no-package-screen";

export const VIEW_SHOP = "view-shop";
export const SEND_ITEMS = "send-items";

export const ASSIGN_SELECTED = "assign-selected";
export const ASSIGN_ALL = "assign-all";

export const REMOVE_UNAVAILABLE_ITEMS = "remove_unavailable_items";

export const HOMEPAGE = "homepage";
export const LIVE_ORDER_LISTING = "live-order";
export const SWAG_AND_DESIGNS = "swag-and-designs";
export const HRIS_CONTACTS_DETAILS_MISSING = "HRIS-contacts-details-missing";
export const NEW_ON_STADIUM = "new-on-stadium";

export const DONE_CTA = "done";
export const ADD_FUNDS_CTA = "add-funds";
export const CREATE_SHARED_WALLET_SUCCESS = "create-shared-wallet-success";

export const DEFAULT_SERVICES = Object.freeze([JUNE_SO]);

export const SHOP_CREATION_FLOW = DEFAULT_SERVICES;
export const ORDER_CONFIRMATION_FLOW = DEFAULT_SERVICES;
export const PRICELESS_FLOW = DEFAULT_SERVICES;
export const EDIT_CATALOG_FLOW = DEFAULT_SERVICES;
export const CREATE_SHARED_WALLET_MODAL_SERVICES = DEFAULT_SERVICES;
